module.exports = __webpack_public_path__ + "img/icon_bg12.a5875ac3.png";